import { Tabs as MuiTabs, TabsProps as MuiTabsProps, useTheme } from "@mui/material";

export interface TabsProps extends MuiTabsProps {
  tabsColor?: "primary" | "secondary";
}

export const Tabs = ({ tabsColor, children, sx, ...props }: TabsProps) => {
  const theme = useTheme();

  const selectedColor = (() => {
    if (tabsColor === "primary") {
      return {
        active: theme.palette.primary.main,
        inactive: theme.palette.cedePrimaryColorLight,
      };
    }
    if (tabsColor === "secondary") {
      return {
        active: theme.palette.secondary.main,
        inactive: theme.palette.cedeSecondaryColorDark,
      };
    }
    return {
      active: theme.palette.cedeTextPrimaryColor,
      inactive: theme.palette.cedeTextDisabled,
    };
  })();

  return (
    <MuiTabs
      TabIndicatorProps={{
        sx: {
          backgroundColor: selectedColor.active,
        },
        ...props.TabIndicatorProps,
      }}
      sx={{
        "& button": {
          color: selectedColor.inactive,
        },
        "& button.Mui-selected": {
          color: selectedColor.active,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiTabs>
  );
};
